// Extreme-zone helpers for the Weighted Market Returns tables (Overview +
// Market Indicators). MFI/RSI rows carry `levels` = composite level N days
// ago; cells get flagged when that level was in an overbought/oversold zone.
export const wmCellExtreme = (row, w) => {
  if (row.kind !== "points" || !row.levels) return null;
  const lvl = row.levels[w];
  if (lvl == null) return null;
  if (lvl >= 80) return { cls: "bg-red-950/70 ring-1 ring-red-500/70", label: "extremely overbought", lvl };
  if (lvl >= 70) return { cls: "bg-orange-950/60 ring-1 ring-orange-500/60", label: "overbought", lvl };
  if (lvl <= 20) return { cls: "bg-emerald-950/70 ring-1 ring-emerald-500/70", label: "extremely oversold", lvl };
  if (lvl <= 30) return { cls: "bg-blue-950/60 ring-1 ring-blue-500/60", label: "oversold", lvl };
  return null;
};

export const wmCurrentBadge = (row) => {
  if (row.kind !== "points" || row.current == null || !row.levels) return null;
  const c = row.current;
  if (c >= 80) return { text: "EXTREME OVERBOUGHT", cls: "text-red-300 border-red-600 bg-red-950/60" };
  if (c >= 70) return { text: "OVERBOUGHT", cls: "text-orange-300 border-orange-600 bg-orange-950/50" };
  if (c <= 20) return { text: "EXTREME OVERSOLD", cls: "text-emerald-300 border-emerald-600 bg-emerald-950/60" };
  if (c <= 30) return { text: "OVERSOLD", cls: "text-blue-300 border-blue-600 bg-blue-950/50" };
  return null;
};
